import React from 'react';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import Slide from '@material-ui/core/Slide';

import { constructWhatsappLink } from '../../components/Fragment/Utility';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const DialogShowAds=React.memo((props)=>{
  const {
    adsToPreview,
    handleCloseAds,
  }=props


  const [price,setPrice]=React.useState("")
  React.useEffect(()=>{
    let p=adsToPreview?.purchasePrice||0
    setPrice("Rp "+p.toLocaleString("ID-id"))
  },[adsToPreview])

  const handleClickPurchase=React.useCallback(()=>{
    window.open(adsToPreview?.purchaseURL)
  },[adsToPreview])

  const handleClickWA=React.useCallback(()=>{
    window.open(constructWhatsappLink(adsToPreview?.sellerPhone,"Saya mau beli:\n"+(adsToPreview?.name||"")+"\nID:"+(adsToPreview?.id||"")+"\n\n",true))
  },[adsToPreview])

  const [showPurchaseDetail,setShowPurchaseDetail]=React.useState(false)
  const handleChangeDetail=React.useCallback((event, isExpanded)=>{
    setShowPurchaseDetail(isExpanded)
  },[])

  React.useEffect(()=>{
    if(showPurchaseDetail){

    }
  },[showPurchaseDetail])

  return (
    <Dialog
      open={!!adsToPreview}
      TransitionComponent={Transition}
      //keepMounted
      onClose={handleCloseAds}
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle>
        <IconButton
          size="small"
          style={{
            float:"right",
          }}
          onClick={handleCloseAds}
        >
          <CloseIcon/>
        </IconButton>
        <Typography
          component="span"
          variant="h4"
        >
          {adsToPreview?.name||""}
        </Typography>
        
      </DialogTitle>
      <DialogContent
        style={{
          textAlign:"center"
        }}
      >
        <a href={adsToPreview?.photoURL||"#"} target="_blank" rel="noopener noreferrer">
          <img
            style={{
              height:"200px",
              width:"200px",
              objectFit:"contain",
              border:"1px solid black",
            }}
            src={adsToPreview?.photoURL||"#"}
            alt="iklan"
          />
        </a>

        <DialogContentText
          style={{
            margin:"8px 0px",
          }}
        >
          {adsToPreview?.description}
        </DialogContentText>
        
        <Typography
          variant="h4"
          style={{
            marginTop:"28px",
            marginBottom:"8px",
            fontWeight:"bold",
          }}
        >
          {price}
        </Typography>
        {adsToPreview?.purchaseURL&&<Button
          color="secondary"
          variant="contained"
          onClick={handleClickPurchase}
          fullWidth
          startIcon={<OpenInNewIcon/>}
          style={{
            marginBottom:"28px"
          }}
        >Cek Produk</Button>}
        {adsToPreview?.sellerPhone&&<Button
          color={!!adsToPreview?.purchaseURL?"primary":"secondary"}
          variant={!!adsToPreview?.purchaseURL?"outlined":"contained"}
          onClick={handleClickWA}
          fullWidth
          startIcon={<WhatsAppIcon style={{color:!!adsToPreview?.purchaseURL?"green":"white"}} />}
        >Hubungi {adsToPreview?.sellerName||"Penjual"}</Button>}

      </DialogContent>
      <DialogActions
        style={{
          padding:"24px 24px 16px"
        }}
      >
        Powered by&nbsp;<a href="https://cari-iklan.web.app" target="_blank" rel="noopener noreferrer">cari-iklan.web.app</a>
      </DialogActions>
    </Dialog>
  )
})


export default DialogShowAds